import ContextMenu from 'components/global/ContextMenu';
import { handleClickDeleteInvite, handleClickResendInvite } from 'components/views/FounderTeam/_helpers/founderTeam.events';
import { $view } from 'signals/global.signals';

const InvestorInviteRows = ({ data }) => data?.map((invite) => ({
  id: invite.id,
  email: invite.email,
  team: $view.value?.teamOptions?.find((team) => team.value === invite.teamId)?.label,
  type: $view.value?.userTypeOptions?.find((type) => type.value === invite.userId)?.label,
  Actions: () => (
    <ContextMenu
      menuItems={[
        {
          label: 'Resend',
          onClick: () => handleClickResendInvite(invite.id),
        },
        {
          label: 'Delete',
          onClick: () => handleClickDeleteInvite(invite.id),
        },
      ]}
    />
  ),
}));

export default InvestorInviteRows;
